import { Chip } from "@bp/ui-components";

export type LabelSource = "role" | "class" | "addon" | "parent" | "status";

const LABEL_COLORS: Record<LabelSource, string> = {
  role: "#e83e8c",
  class: "#fd7e14",
  addon: "#17a2b8",
  parent: "#007bff",
  status: "#20c997",
};

type PersonLabelProps = {
  source: LabelSource;
  value: string;
};

export function PersonLabel({ source, value }: PersonLabelProps) {
  const dotColor = LABEL_COLORS[source] ?? "var(--color-grey)";
  return (
    <Chip
      bgColor="var(--color-grey-lightest)"
      color="var(--color-grey-dark)"
      isSmall
      value={
        <span style={{ display: "inline-flex", alignItems: "center", gap: 5 }}>
          <span style={{ width: 6, height: 6, borderRadius: "50%", background: dotColor }} />
          {value}
        </span>
      }
    />
  );
}
